import script from "./caseList.vue?vue&type=script&setup=true&lang=js"
export * from "./caseList.vue?vue&type=script&setup=true&lang=js"

import "./caseList.vue?vue&type=style&index=0&id=1b132056&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b132056"]])

export default __exports__